const toastClassMappings = {
  success: 'toast-success',
  error: 'toast-error',
  info: 'toast-info',
};

const iconClassMappings = {
  success: 'bi-check-circle-fill text-success',
  error: 'bi-x-circle-fill text-danger',
  info: 'bi-info-circle-fill text-info',
};

/**
 * showToast('My message', { type: 'success', delay: 4000 });
 */
export default function showToast(message, { type = 'success', delay = 2000, automaticallyRemoveToast = true } = {}) {
  const toast = document.createElement('div');
  toast.classList.add('toast', 'show');

  if (toastClassMappings[type]) {
    toast.classList.add(...toastClassMappings[type].split(' '));
  }

  toast.setAttribute('data-toast', '');
  toast.setAttribute('role', 'alert');
  toast.setAttribute('aria-live', 'assertive');
  toast.setAttribute('aria-atomic', 'true');
  const headerElement = document.createElement('div');
  headerElement.classList.add('toast-header');

  const iconElement = document.createElement('i');
  iconElement.classList.add('bi', 'mr-2');

  if (iconClassMappings[type]) {
    iconElement.classList.add(...iconClassMappings[type].split(' '));
  }

  headerElement.append(iconElement);

  const messageElement = document.createElement('p');
  messageElement.classList.add('mr-auto', 'mb-0');
  messageElement.innerText = message;
  headerElement.append(messageElement);

  toast.append(headerElement);

  const toastContainer = document.querySelector('.toast-container');
  toastContainer?.append(toast);

  if (automaticallyRemoveToast) {
    setTimeout(() => toast.remove(), delay);
  }

  return () => {
    toast.remove();
  }
}

document.addEventListener('turbolinks:before-cache', () => {
  const toasts = Array.from(document.querySelectorAll('[data-toast]'));
  toasts.forEach((toast) => toast.remove());
});
